import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, map, take, takeUntil } from 'rxjs';

import { GoogleTagManagerFacade } from 'ish-core/facades/gtm.facade';
import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { ProductLinksDictionary } from 'ish-core/models/product-links/product-links.model';
import { ProductView } from 'ish-core/models/product-view/product-view.model';

@Component({
  selector: 'ish-product-detail',
  templateUrl: './product-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailComponent implements OnInit, OnDestroy {
  product$: Observable<ProductView>;
  links$: Observable<ProductLinksDictionary>;
  quantityVisible$: Observable<boolean>;
  hasSuggestedProducts$: Observable<boolean>;
  private destroy$ = new Subject<void>();
  constructor(private context: ProductContextFacade, private gtmFacade: GoogleTagManagerFacade) {}
  ngOnInit() {
    this.product$ = this.context.select('product');
    this.links$ = this.context.select('links');
    this.quantityVisible$ = this.context.select('displayProperties', 'quantity');
    this.hasSuggestedProducts$ = this.links$.pipe(map(links => links?.crossselling?.products.length > 0));
    this.product$.pipe(take(1), takeUntil(this.destroy$)).subscribe(product => {
      const products: ProductView[] = [product];
      this.gtmFacade.triggerGTMEvent('view_item', products);
    });
  }

  setSelectedWarranty(selectedWarranty: string) {
    this.context.setSelectedWarranty(selectedWarranty);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
